import { cn } from '@/utils/helper';

import Alerts from './Alerts';
import NettyScore from './NettyScore';
import Revenue from './Revenue';
import type { FeaturesDataType } from '../home/new/FeaturesSection';
import HomeNettyScore from '../home/new/NettyScore';

const featuresData: FeaturesDataType[] = [
  {
    id: 1,
    advTitle: 'Instant Alerts',
    advText: 'Real Time Updates',
    title: 'Borrowing & Lending Alerts',
    desc: 'Provide users with borrowing and lending alerts, and increase liquidity within your community.',
  },
  {
    id: 2,
    advTitle: 'Netty Score',
    advText: 'Web3 Credit Score',
    title: 'Netty Score',
    desc: "Provides lenders with borrowers' loan history, including repayments and defaults.",
  },
  {
    id: 3,
    advTitle: 'Generate Revenue',
    advText: 'Unlock More Capital',
    title: 'Earn More Revenue ',
    desc: 'Earn revenue with every loan on your dApp, creating steady income while providing value to your users.',
  },
];

const IntegrationSection: React.FC = () => {
  return (
    <section className='mt-[148px] lg:mt-[108px] max-w-[1112px] mx-auto px-[25px]'>
      <hgroup>
        <h2 className='w-fit mx-auto text-center text-[28px]/9 lg:text-[52px]/[60px] font-semibold !text-transparent dark:!text-transparent bg-clip-text bg-[radial-gradient(56%_111.11%_at_50%_50%,#292929_82.64%,#ffffff99_100%)] dark:bg-[radial-gradient(50%_111.11%_at_50%_50%,#fff_82.64%,#ffffff99_100%)]'>Why Integrate With NettyWorth</h2>
        <p className='mt-6 lg:mt-8 text-center text-base lg:text-lg/8 font-normal lg:font-medium text-primary-grey-150 dark:text-white-dark'>Focus on building innovative solutions while we handle the complexity of DeFi infrastructure.</p>
      </hgroup>
      <div className='mt-16 lg:mt-[62px] grid grid-cols-1 md:grid-cols-3 gap-x-3 gap-y-16'>
        {featuresData.map((item) => {
          return (
            <article key={item.id} className='w-full md:max-w-[362px]'>
              <div className={cn('bg-white-100 dark:bg-grey-coal w-full lg:h-[343px] flex flex-col justify-between p-6 lg:p-7 pb-0 lg:pb-0 rounded-[40px] overflow-clip relative', item.advTitle !== 'Netty Score' && item.advTitle !== 'Generate Revenue' && 'h-[292px]')}>
                <div className=' pb-1 lg:pb-3 flex items-center justify-between'>
                  <div>
                    <strong className='text-black dark:text-white text-lg/6 font-medium'>{item.advTitle}</strong>
                    <p className='lg:mt-0.5 text-sm/4 !text-grey-coal-light font-normal'>{item.advText}</p>
                  </div>

                  {item.advTitle === 'Generate Revenue' && <p className='flex lg:hidden text-[13px]/[22px] self-end rounded-[64px] !text-[#05CD99] w-[66px] h-[27px] bg-[rgba(5,_205,_153,_0.20)] items-center justify-center'>+2.45%</p>}
                </div>

                {item.advTitle === 'Instant Alerts' ? (
                  <Alerts />
                ) : item.advTitle === 'Netty Score' ? (
                  <>
                    <div className='hidden md:flex flex-col justify-between items-center'>
                      <NettyScore />
                    </div>
                    <div className='bg-white-100 dark:bg-grey-coal w-full lg:h-[470px] h-[350px] flex md:hidden flex-col justify-between p-6 sm:p-[30px] lg:p-12 pb-0 lg:pb-0 rounded-[40px] overflow-clip relative'>
                      <HomeNettyScore />
                    </div>
                  </>
                ) : (
                  <Revenue />
                )}
              </div>
              <div className='flex flex-col items-center md:items-start'>
                <h3 className='mt-12 lg:mt-[35px] text-coal-250 dark:text-primary text-xl lg:text-2xl font-medium w-full flex justify-center md:justify-start'>{item.title}</h3>
                <p className='max-w-[340px] mt-4 text-base lg:text-lg/8 text-primary-grey-150 dark:text-white-dark font-medium text-center md:text-start'>{item.desc}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default IntegrationSection;
